// React Compoment
import React from 'react';

// Features
import { UsersReferral } from '../../features/auth';
import { AuthLayout } from '../../layouts'

const ReferralView = () => {
    return (
        <AuthLayout rightPanelVariant="light">
            <UsersReferral />
        </AuthLayout>
    )
}

export default ReferralView;

